import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import Booking from './Booking'
import Footer from './Footer'
import Clients from './Clients'

import { MdPayment } from "react-icons/md";
import {  FaChartLine, FaCreditCard, FaUserCog, FaDesktop, FaShieldAlt } from "react-icons/fa";

import an from '../../PaymentsImage/analytics.jpeg';
import mcp from '../../PaymentsImage/multichannelpayment.png';

import pr from '../../PaymentsImage/personalisedrequest.png';

import sc from '../../PaymentsImage/security.png';
import ti from '../../PaymentsImage/Terminalintegration.png';
import fs from '../../Assets/payment1.png';
import { useNavigate } from 'react-router-dom'




function Payments() {
  const navigate = useNavigate();

  const analyticsPaymentsData = [
    {
      icon: <FaChartLine />,
      iconTitle: 'Analytics',
      image: an,
      title: 'Utilize analytics to make informed decisions and improve payment processing efficiency.',
      lines: [
        'Track and analyze transaction data for insights.',
        'Identify areas for improvement in payment operations.',
        'Make data-driven decisions to enhance payment processing.'
      ],
    },
  ];
  const multipleChannelAcceptanceData = [
    {
      icon: <FaCreditCard />,
      image: mcp,
      iconTitle: 'Multiple Channel Acceptance',
      title: 'Accept payments seamlessly across multiple channels for a broader customer reach.',
      lines: [
        'Enable payment acceptance through various channels.',
        'Provide flexibility for customers to choose preferred payment methods.',
        'Optimize payment infrastructure for a seamless customer experience.'
      ],
    },
  ];
  const personalizedRequestsData = [
    {
      icon: <FaUserCog />,
      iconTitle: '1:1 Personalized Requests',
      image: pr,
      title: 'Address individualized payment requests for a personalized and efficient payment experience.',
      lines: [
        'Handle personalized payment requests from individual customers.',
        'Offer tailored payment solutions based on customer needs.',
        'Enhance customer satisfaction with personalized payment interactions.'
      ],
    },
  ];
  const terminalIntegrationData = [
    {
      icon: <FaDesktop />,
      image: ti,
      iconTitle: 'Terminal Integration',
      title: 'Integrate payment terminals for streamlined in-person transactions and enhanced security.',
      lines: [
        'Connect payment terminals to your system for seamless processing.',
        'Ensure secure and efficient in-person transactions with terminal integration.',
        'Enhance user experience with integrated payment solutions.'
      ],
    },
  ];
  const securityPaymentsData = [
    {
      icon: <FaShieldAlt />,
      image: sc,
      iconTitle: 'Security',
      title: 'Prioritize the security of payment transactions with robust encryption and protective measures.',
      lines: [
        'Implement encryption protocols to secure payment data.',
        'Utilize security measures to prevent fraud and unauthorized access.',
        'Ensure compliance with industry standards for secure payment processing.'
      ],
    },
  ];
  
  
  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <MdPayment className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Payments</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>Seamless Transactions,<br /> Unmatched Security.</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '> Accept payments seamlessly across multiple channels, providing flexibility for customers. Address personalized payment requests with tailored solutions, enhancing individual customer experiences. Integrate terminals for secure in-person transactions and prioritize robust security measures for data protection.
        </span>
        
            
            <button onClick={() => navigate('/waitlist')}  className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className=' w-full lg:w-[50%]'>
     <img className=' xl:h-[500px] aspect-auto rounded-2xl' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

        {/* 3rd Section */}
    
  {/* 4th Section */}
  <PageSection bg  data={analyticsPaymentsData} />

  <PageSection reverse  data={multipleChannelAcceptanceData} />
  {/* <Clients /> */}


  <PageSection   data={personalizedRequestsData} />


  <PageSection reverse  data={terminalIntegrationData}  />

  <PageSection   data={securityPaymentsData} />


  <Branding />





  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default Payments
